const JavaBattleship: React.FC = () => {
    return (
        <iframe height="315" src="https://www.youtube.com/embed/43NnsHyYLHY" title="YouTube video player" frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
    );
}

export default JavaBattleship;